<template>
  <section>
    <div
      id="myModal"
      class="fixed z-50 pt-0 sm:pt-16 w-full h-full overflow-auto left-0 top-0"
      style="background: rgba(48, 47, 60, 0.5)"
      v-if="toggleForm"
      @click.self="closeModal()"
    >
      <div
        id="newsletter-button"
        class="shadow-allArround ease-in-out bg-transparent z-40 rounded-lg fixed top-1/2 left-1/2"
        style="transform: translate(-50%, -50%)"
      >
        <div>
          <div class="mt-0 sm:mx-auto sm:w-full sm:max-w-md">
            <div
              class="px-4 pt-4 pb-8 bg-white border shadow border-gray-50 rounded-lg sm:p-7"
            >
              <XIcon
                class="text-gray-400 text-4xl font-bold hover:text-primary-color cursor-pointer absolute top-4 right-4"
                style="transform: scale(1.3)"
                @click="closeModal()"
              ></XIcon>

              <div class="flex justify-center items-center">
                <span
                  class="flex justify-center box-border text-3xl font-bold leading-none tracking-wide text-center border-solid mb-2"
                >
                  Newsletter
                </span>
              </div>

              <div class="flex justify-center">
                <span
                  class="box-border text-base leading-none tracking-wide text-center border-solid my-4"
                >
                  The latest posts delivered to your inbox.
                </span>
              </div>
              <div>
                <label
                  for="newsletter_name"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Name</label
                >
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="newsletter_name"
                    type="text"
                    name="newsletter_name"
                    required="required"
                    class="w-full"
                    v-model="data.newsletter_name"
                    placeholder="First and last name"
                  />
                </div>

                <div class="error" v-if="errors.newsletter_name">
                  {{ errors.newsletter_name }}
                </div>
              </div>
              <div class="mt-6">
                <label
                  for="newsletter_email"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Email
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="newsletter_email"
                    type="email"
                    name="newsletter_email"
                    required="required"
                    class="w-full"
                    v-model="data.newsletter_email"
                    placeholder="example@email.com"
                  />
                </div>
                <div class="error" v-if="errors.newsletter_email">
                  {{ errors.newsletter_email }}
                </div>
              </div>

              <div class="mt-6">
                <span class="block w-full rounded-md shadow-sm">
                  <button @click="sendNewsletter()" class="btn-primary w-full">
                    Subscribe
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { XIcon } from "@vue-hero-icons/outline";

export default {
  props: {
    errors: Object,
  },
  components: {
    XIcon,
  },

  mounted() {
    if (this.getCookie("NEWSLETTER-POPUP") === null) {
      window.addEventListener("scroll", this.handleScroll);
    }
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  data() {
    return {
      data: {
        newsletter_name: null,
        newsletter_email: null,
      },
      toggleForm: false,
      openModelTimer: null,
    };
  },
  methods: {
    /**
     * Displays a newsletter by opening a modal after a delay.
     *
     * @returns {void}
     */
    showNewsletter() {
      this.openModelTimer = setTimeout(() => this.openModal(), 10000);
    },

    /**
     * Sends a newsletter by making a POST request to the specified endpoint with the provided data.
     *
     * @returns {void}
     */
    sendNewsletter() {
      this.$inertia.post("/newsletter", this.data, {
        preserveScroll: true,
        onSuccess: (e) => {
          if (e.props.flash.message != null) {
            this.$store.commit("showFlashMessage", {
              message: e.props.flash.message,
              type: e.props.flash.message_type,
            });
            this.closeModal();
          }
        },
      });
    },

    /**
     * Opens a modal by toggling a boolean flag that controls its visibility.
     *
     * @returns {void}
     */
    openModal() {
      if (this.getCookie("NEWSLETTER-POPUP") === null) {
        this.toggleForm = true;
      }
    },

    /**
     * Closes a modal by calling a method or function to handle the closure.
     *
     * @returns {void}
     */
    closeModal() {
      this.handleClose(2);
    },

    /**
     * Handles the closure of a modal by toggling its visibility and setting a cookie with a specified duration.
     *
     * @param {number} duration - The duration for which the cookie should be set (in days).
     * @returns {void}
     */
    handleClose(duration) {
      this.toggleForm = !this.toggleForm;
      this.setCookie("NEWSLETTER-POPUP", duration);
    },

    /**
     * Sets a cookie with the specified name and duration.
     *
     * @param {string} cookieName - The name of the cookie to be set.
     * @param {number} duration - The duration for which the cookie should be set (in days).
     * @returns {void}
     */
    setCookie(cookieName, duration) {
      const d = new Date();
      d.setTime(d.getTime() + duration * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cookieName + "=" + ";" + expires + ";path=/";
    },

    /**
     * Retrieves the value of a cookie with the specified name.
     *
     * @param {string} cookieName - The name of the cookie to retrieve.
     * @returns {string|null} - The value of the cookie, or null if the cookie is not found.
     */
    getCookie(cookieName) {
      let name = cookieName;
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return null;
    },

    /**
     * Event handler for scrolling that triggers the display of a newsletter.
     *
     * @returns {void}
     */
    handleScroll() {
      if (!this.openModelTimer) {
        this.showNewsletter();
      }
    },
  },
};
</script>